module.exports = __webpack_public_path__ + "media/images/header-large.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/header-large.jpg
// module id = 67
// module chunks = 0